import "./JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import ToolActionButtons from "../../Components/ToolActionButtons";
import { Row, Col } from "react-bootstrap";
import { useState } from "react";
import { Beautify, Minify } from "../../Services/APIService";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { ExampleJSON, ExampleMinifiedJSON } from "../../Services/Tools";
import { InputHeaderButtons, OutputHeaderButtons } from "./JSONToolsHeaderButtons";


function JSONFormatter() {
    const [text, setText] = useState("");
    const [beautifyReqBody, setBeautifyReqBody] = useState();
    const [minifyReqBody, setMinifyReqBody] = useState();
    const [result, setresult] = useState("")
    const indent = 2;
    const toolFav = { toolName: 'JSON Formatter', Iconpath: "/FileCodeRaw.svg" };
    const [activeAction, setActiveAction] = useState("minify");
    const [, setIsValid] = useState(true);
    const [recentInput, setRecentInput] = useState("");

    

    


    const lineCount = text !== "" ? (text || "").split("\n").length : 0;
    const resultLineCount = result !== "" ? (result ?? "").toString().split("\n").length : 0;

    const handleChange = (e) => {
        setText(e.target.value);
        
        setBeautifyReqBody({
            input: e.target.value,
            indent: indent
        });
        setMinifyReqBody({
            input: e.target.value
        });
    };


    const formatJson = () => {
        if(text.trim() === "") {
            setresult("Please enter JSON data to format.");
            return;
        }
        if (text === recentInput) {
            alert("No changes detected in the input JSON.");
            return;
        }
        else {
            setRecentInput(text);
        }
        if (activeAction === "minify") {
            MinifyJOSN();
        }
        else {
            BeautifyJSON();
        }
    }

    const pasteExample = () => {
        if (activeAction === "minify") {
            const exampleText =
                typeof ExampleJSON === "string"
                    ? ExampleJSON
                    : JSON.stringify(ExampleJSON, null, indent);

            setText(exampleText);
            setMinifyReqBody({
                input: exampleText
            });;
        }
        else {
            const exampleText = JSON.stringify(ExampleMinifiedJSON);
            console.log(text);
            setText(exampleText);
            setBeautifyReqBody({
                input: exampleText,
                indent: indent
            });
        }
    };


    const handleImport = (filecontent) => {
        setText(filecontent);

        setBeautifyReqBody({
            input: filecontent,
            indent: indent
        });

        setMinifyReqBody({
            input: filecontent
        });

    };

    const MinifyJOSN = async () => {
        try {
            const response = await Minify(minifyReqBody);
            setresult(response.data.minifiedJson);
            setIsValid(true);
        } catch (error) {
            if (error.response?.status === 400) {
                const apiMessage =
                    error.response?.data?.message;
                setresult(apiMessage);
                setIsValid(false);
            } else {
                setresult("Something went wrong. Please try again.");
                setIsValid(false);
            }
        }
    };

    const BeautifyJSON = async () => {
        try {
            const response = await Beautify(beautifyReqBody);
            setresult(response.data.formattedJson);
            setIsValid(true);
        } catch (error) {
            if (error.response?.status === 400) {
                const apiMessage =
                    error.response?.data?.message;

                setresult(apiMessage);
                setIsValid(false);
            } else {
                setresult("Something went wrong. Please try again.");
                setIsValid(false);
            }
        }
    };


    const runAction = async (action) => {
        setActiveAction(action);
        setText("");
        setresult("");
    }
    return (
        <>
            <Col>
                <ToolHeader title="JSON Formatter" description="Format and validate JSON data" toolFav={toolFav} />

                <ToolActionButtons
                    actions={[
                        { label: "Minify", value: "minify" },
                        { label: "Beautify", value: "beautify" }
                    ]}
                    activeValue={activeAction}
                    onAction={(action) => runAction(action.value)}
                />

                <Row className='Formatter json-formatter-row'>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Input JSON"
                            value={text}
                            onChange={(e) => handleChange(e)}
                            placeholder="Paste your JSON here..."
                            lineCount={lineCount}
                            editorContainerStyle={{ overflow: "auto" }}
                            wrap={false}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={pasteExample}
                                    onClear={() => {
                                        setText("");
                                        setBeautifyReqBody("");
                                        setMinifyReqBody("");
                                        setresult("");
                                    }}
                                    onImport={(fileContent) => handleImport(fileContent)}
                                    accept=".json"
                                    executeLabel={"Format"}
                                    showExecute={true}
                                    onExecute={formatJson}
                                />
                            }
                            footerLeft={`Characters : ${text.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([text]).size} B`}
                        />
                    </Col>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Formatted JSON"
                            value={result ?? ""}
                            placeholder="Formatted JSON will appear here..."
                            lineCount={resultLineCount}
                            editorContainerStyle={{ overflow: "auto" }}
                            wrap={false}
                            readOnly
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName="formatted.json"
                                    mimeType="application/json;charset=utf-8"
                                />
                            }
                            footerLeft={`Characters : ${result.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default JSONFormatter;
